import styled from "styled-components";

export const SectionCard=styled.div`
    background: #e9ecef;
    border: 1px solid #dee2e6!important;
    border-radius: .25rem!important;
    margin: .5rem 0!important;
    padding: .5rem!important;
`;
